/**
 * Created by qingzhui on 17/1/1.
 */

require('../../scss/m/m-index.scss');

require('./m-common');
var $ = require('jquery');

$('.showHidden').click(function(){
    if($('.showHidden').hasClass('active')){
        $('.showHidden').removeClass('active')
        $('.showHidden ul').slideUp()
    }else{
        $('.showHidden').addClass('active')
        $('.showHidden ul').slideDown()
    }

})
$('.showHidden a').click(function(event) {
    event.stopPropagation();
});


// WEBPACK FOOTER //
// ./src/m/m-disclosure.js